import React from 'react';
import PropTypes from 'prop-types';

import SearchResult from '../search-result/SearchResult';

const SearchResults = ({
  searchTerm,
  results,
  rootUrl,
  moneyFormat,
  viewAllString,
  typeProductsTitle,
  typeCollectionsTitle,
}) => {
  const {collections, products} = results;
  const totalResults = products.length + collections.length;

  let productsCountString = products.length === 1 ? window.theme.strings.search?.resultsCount?.one : window.theme.strings.search?.resultsCount?.other;
  productsCountString = productsCountString.replace('{{ count }}', products.length);

  const renderResultGrid = (src, title, type) => (
    <div className={`quick-search-results__section quick-search-results__section--${title}`}>
      {type === 'product' ? (
        <div className="quick-search-results__header">
          <p>{productsCountString}</p>
          <a href={`${rootUrl}/search?type=product&q=${searchTerm}*`}>{viewAllString}</a>
        </div>
      ) : (
        <div className="quick-search-results__header small-down--hide">
          <p>{typeCollectionsTitle}</p>
        </div>
      )}
      <div className={`quick-search-results__grid quick-search-results__grid--${title}`}>
        {src.map((result) => (
          <SearchResult key={result.id} result={result} type={type} moneyFormat={moneyFormat} searchTerm={searchTerm} />
        ))}
      </div>
    </div>
  );

  return (
    <div className="quick-search-results">
      {totalResults < 1 && (
        <p>
          Sorry, no top results for &quot;<em className="quick-search-results__search-term">{searchTerm}</em>&quot;.
        </p>
      )}

      {collections.length >= 1 && renderResultGrid(collections, typeCollectionsTitle, 'collection')}

      {products.length >= 1 && renderResultGrid(products, typeProductsTitle, 'product')}
    </div>
  );
};

const TypeCoreResult = {
  id: PropTypes.number,
  url: PropTypes.string,
  title: PropTypes.string,
};

const TypeImageResult = {
  /* eslint-disable babel/camelcase */
  featured_image: PropTypes.shape({
    url: PropTypes.string,
    aspect_ratio: PropTypes.number,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  /* eslint-enable babel/camelcase */
};

const TypeFormResult = {
  variants: PropTypes.array,
};

SearchResults.propTypes = {
  searchTerm: PropTypes.string,
  results: PropTypes.shape({
    products: PropTypes.arrayOf(
      PropTypes.shape({
        ...TypeCoreResult,
        ...TypeImageResult,
        ...TypeFormResult,
        price: PropTypes.string,
      })
    ),
    collections: PropTypes.arrayOf(
      PropTypes.shape({
        ...TypeCoreResult,
        ...TypeImageResult,
      })
    ),
  }).isRequired,
  rootUrl: PropTypes.string.isRequired,
  moneyFormat: PropTypes.string.isRequired,
  typeProductsTitle: PropTypes.string,
  typeCollectionsTitle: PropTypes.string,
  viewAllString: PropTypes.string,
};

export default SearchResults;
